export enum PartySefaEnum {
  asala = 1,
  CompanyOwner = 4,
  bemogabWekala = 29,
  companyRepresentative = 34,
  FourthRelation = 36,
  Lawyer = 35,
  TrainerLawyer = 38
}



